import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityCard = ({ activity }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'Reunião':
        return 'Users';
      case 'Manutenção':
        return 'Settings';
      case 'Instalação':
        return 'Plus';
      case 'Treinamento':
        return 'BookOpen';
      case 'Auditoria':
        return 'Search';
      default:
        return 'Calendar';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Reunião':
        return 'text-primary bg-primary/10';
      case 'Manutenção':
        return 'text-warning bg-warning/10';
      case 'Instalação':
        return 'text-success bg-success/10';
      case 'Treinamento':
        return 'text-accent bg-accent/10';
      case 'Auditoria':
        return 'text-secondary bg-secondary/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-professional transition-all duration-200">
      <div className="flex items-start space-x-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getTypeColor(activity?.type)}`}>
          <Icon name={getActivityIcon(activity?.type)} size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <h4 className="font-medium text-card-foreground truncate">
              {activity?.title}
            </h4>
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTypeColor(activity?.type)}`}>
              {activity?.type}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">
            {activity?.description}
          </p>
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <div className="flex items-center space-x-3">
              <div className="flex items-center">
                <Icon name="Calendar" size={14} className="mr-1" />
                <span>{activity?.date}</span>
              </div>
              <div className="flex items-center">
                <Icon name="Clock" size={14} className="mr-1" />
                <span>{activity?.time}</span>
              </div>
            </div>
            {activity?.technician && (
              <div className="flex items-center">
                <Icon name="User" size={14} className="mr-1" />
                <span>{activity?.technician}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;